import { useMedplum } from "@medplum/react-hooks";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { AIModels } from "@/components/ai-models";
import { ProfileCard } from "@/components/profile-card";
import { aiModelQueries } from "@/hooks/queries/ai-models";

export const Route = createFileRoute("/settings/_layout/")({
  component: SettingsIndexPage,
});

function SettingsIndexPage() {
  const { data: aiModels = [] } = useQuery(aiModelQueries.list());
  const medplum = useMedplum();

  return (
    <div className="py-12 space-y-12">
      <ProfileCard profile={medplum.getProfile()} project={medplum.getProject()} />
      <AIModels models={aiModels} />
    </div>
  );
}
